import { Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';

import AppTemplate from 'shared/components/AppTemplate';
import Login from 'shared/components/Login';
import EnvConfig from "shared/libraries/mwc/envConfig";
import themeProvider from 'shared/themes/default';

import App from './App';

EnvConfig.autoDetectEnvironment();

export default function AppRouter() {
  const companySlug = EnvConfig.getCompanySlug();
  return (
    <AppTemplate
      title="Modsy Home Viewer"
      description="View your home in 3D"
    >
      <ThemeProvider theme={themeProvider()}>
        <Routes>
          <Route
            path="login"
            element={<Navigate to={`/home-viewer/${companySlug}/login`} replace />}
          />
          <Route
            path={`${companySlug}/login`}
            element={
              <Login
                env={EnvConfig.getKeyCloakEnvironment()}
                companySlug={companySlug}
                title="Welcome to Home Viewer"
                description="View your home in 3D"
                navigateTo="/home-viewer"
              />
            }
          />

          <Route path="*" element={<App />} />
        </Routes>
      </ThemeProvider>
    </AppTemplate>
  );
}
